/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Typography } from '@material-ui/core';

function ProductComingSoon({ goBack }) {
  return (
    <Box p={4} textAlign="center">
      <Typography variant="h2" color="textPrimary">
        Coming Soon
      </Typography>
      <br />
      <Typography variant="body1" color="textSecondary">
        Filing Glass claims is not yet supported.
      </Typography>
      <Typography variant="body1" color="textSecondary">
        We are working to support more products in our portal. Once
        we're done you'll be able to file Glass claims.
      </Typography>
      <Box mt={6}>
        <Button
          onClick={goBack}
          size="large"
          variant="outlined"
        >
          Previous
        </Button>
      </Box>
    </Box>
  );
}

ProductComingSoon.propTypes = {
  goBack: PropTypes.func,
};

export default ProductComingSoon;
